export const isReactNativeWebView = () => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined')
    return false;
  return (
    !!(window as Window & { ReactNativeWebView?: unknown })
      .ReactNativeWebView || navigator.userAgent.includes('wv')
  );
};

export enum AvailableLanguageTypes {
  ENGLISH = 'en',
  THAI = 'th',
}

export const CURRENCY_SYMBOL = 'RM';

// Formats a number with comma separators (e.g. 1000000 -> 1,000,000)
export const formatNumber = (value: number): string => {
  return value.toLocaleString('en-US');
};
